<div class="satured-chip">
  <span class="satured-chip-text ci-paragraph-p1-regular">
    {{ 'Saturado' | translate }}
  </span>
</div>